import './Banner.css'
import contact from '../assets/contact.png';

function Banner() {
  return (
    <div className="banner">
      <div className="banner-content">
        <div className="banner-left">
          <h1>CONTACT US</h1>
          <div className="breadcrumb">
            <a href="/">Home</a>
            <span className="separator">›</span>
            <span>Contact Us</span>
          </div>
        </div>
        <div className="banner-right">
          <img
            src={contact}
            alt="HVAC Technician"
          />
        </div>
      </div>
    </div>
  )
}

export default Banner
